var nBody;

$.fn.notify = function(scrollTop) {
  var parent = this;

  parent.bindNotify = function(selector) {
    var alert = $(selector);

    if (alert.length) {
      alert.find('a.close').on('click.notify', function() {
        parent.hideNotify(alert);

        var closePermanentId = alert.data('closePermanentId');
        if(closePermanentId) {
          userResource.dismissMessage(closePermanentId);
        }
      });

      var autoClose = alert.data('autoClose');
      if(autoClose) {
        setTimeout(function() {
          parent.hideNotify(alert);
        }, autoClose * 1000);
      }
    }
  };

  parent.addNotify = function(message, type, close, autoClose, sendLater, closePermanentId) {
    message = message || '';
    type = type || 'success';
    close = close || true;
    autoClose = autoClose || 5;
    closePermanentId = closePermanentId || false;

    // send the alert after a page load
    if(sendLater) {
      sessionStorage.setItem('alert', JSON.stringify({
        message: message,
        type: type,
        closeable: close,
        autoClose: autoClose
      }));
      return;
    }

    var container = $('<div class="notify-container"></div>').text(message);
    var alert = $('<div class="notify" data-auto-close="' + autoClose + '" ' + 'data-close-permanent-id="' + closePermanentId + '" style="display:none"></div>').addClass('notify-' + type);
    alert.prepend(container);

    if(close) {
      container.prepend('<a class="close" aria-label="Close"><span aria-hidden="true">&times;</span></a></div>');
    }

    alert.appendTo($(parent)).slideDown(150);

    parent.bindNotify(alert);

    if (scrollTop) {
      nBody.animate({ scrollTop: 0 }, 200);
    }
  };
  
  parent.hideNotify = function(elm) {
    var elm = elm || parent.find('.notify');
    elm.slideUp(200, function() {
      elm.remove();
    });
  }

  return parent;
};


$(function() {
  nBody = $('html, body');

  var notifications = $('#notify');

  var AVNotify = notifications.notify(true);

  notifications.find('.notify').each(function() {
    AVNotify.bindNotify($(this));
  });

  window.AVNotify = function() {
    AVNotify.addNotify.apply(null, arguments);
  };

  // show and remove stored alerts
  if(sessionStorage.getItem('alert')) {
    var info = JSON.parse(sessionStorage.getItem('alert'));
    window.AVNotify(info.message || '', info.type || 'success', info.closeable || true, info.autoClose || 5);
    sessionStorage.removeItem('alert');
  }
});
